export enum BookingObjectPricePolicyWorkModeEnum {
    Unset = 0,
    ManageDefaultFromBookingObjectPage = 1,
    Create = 2,
    Update = 3
}
